import React from 'react';
import SavedPresetControls from './SavedPresetControls';

interface Props {
	selectedDatasetIds: number[];
	onLoad: (datasetIds: number[]) => void;
}

function parseDatasetIds(value: unknown): number[] | null {
	if (!Array.isArray(value)) return null;
	const datasetIds = Array.from(new Set<number>(value.filter(
		(datasetId): datasetId is number => Number.isSafeInteger(datasetId) && datasetId > 0,
	)));
	return datasetIds.length > 0 ? datasetIds : null;
}

export default function MatrixDatasetLayouts({ selectedDatasetIds, onLoad }: Props) {
	return (
		<SavedPresetControls
			storageNamespace="admin.symbolMatrix.datasetSelections.v2"
			noun="selection"
			currentValue={selectedDatasetIds}
			canSave={selectedDatasetIds.length > 0}
			parseValue={parseDatasetIds}
			onLoad={onLoad}
			formatOptionLabel={(name, datasetIds) => `${name} (${datasetIds.length})`}
		/>
	);
}
